/**
 * Public distribution links for the app. Shared so the landing page, the support
 * page and any email template point at the same place.
 *
 * `testflight` is the public TestFlight invite link (App Store Connect → TestFlight →
 * the external group → "Public link"). Leave it empty until that link exists: the
 * landing page then falls back to a mailto invite instead of a dead button.
 */
export const APP_LINKS = {
    testflight: '',
    appStore: '',
    googlePlay: '',
};
//# sourceMappingURL=links.js.map